<p-dialog [visible]="store.open()" (visibleChange)="onVisibleChange($event)" (onHide)="onHidden()"
    [modal]="true" [closable]="true" [dismissableMask]="true" [draggable]="false" [resizable]="false"
    [closeOnEscape]="false" [dismissableMask]="true" [showHeader]="false"
    [position]="sidebar ? 'right' : 'center'"
    [baseZIndex]="store.overPlayer() ? 1000001 : 0"
    [maskStyleClass]="store.overPlayer() ? '' : 'details-mask-below-player'"
    [style]="sidebar
        ? { width: '800px', maxWidth: '96vw', height: '100vh', maxHeight: '100vh', margin: '0' }
        : { width: '800px', maxWidth: '96vw' }"
    [styleClass]="sidebar ? 'overflow-hidden rounded-l-2xl' : 'overflow-hidden rounded-2xl'"
    contentStyleClass="!p-0 !relative !overflow-hidden">

    <!-- Pinned close button: sibling of the scroller so it stays put while content scrolls. -->
    <rounded-icon-button class="!absolute top-4 right-4 z-20" [imgSrc]="skinning.getImage('icon_close')"
        (onClick)="close()" data-testid="details_close"></rounded-icon-button>

    <!-- Scroller. Modal mode hugs its content (caps at 90vh, so the dialog sizes to it — no dead
         space above/below). Sidebar mode fills the full-height panel. Content scrolls flush to top. -->
    <div class="overflow-y-auto pb-4 bg-[var(--background_primary)]" data-testid="details_panel"
        [style.height]="sidebar ? '100vh' : null"
        [style.maxHeight]="sidebar ? null : '90vh'"
        (click)="$event.stopPropagation()">

        @if (store.loading()) {
            <details-skeleton />
        } @else if (store.item(); as item) {
            <details-header [vm]="item" [channelIcon]="svc.channelIcon()"
                [previewUrl]="svc.previewVideoUrl()"
                [showPlay]="store.showPlayButton()" (play)="play()" />

            <details-actions
                [showPlay]="store.showPlayButton()" [playLabel]="svc.playLabel()"
                [canRecord]="svc.canRecord()" [recorded]="svc.recorded()"
                [canWatchLater]="svc.canWatchLater()" [watchLater]="item.watchLater"
                (play)="play()" (record)="svc.toggleRecord()"
                (toggleWatchLater)="svc.toggleWatchLater()" (share)="svc.share($event)" />

            <details-description [vm]="item" [expanded]="store.descriptionExpanded()"
                (toggle)="store.toggleDescription()" />

            @if (svc.tabs().length) {
                <div class="mt-6 px-8">
                    <tabs-nav [items]="svc.tabs()" [activeId]="store.activeTabId()"
                        (itemSelect)="store.setActiveTab($any($event.id))"></tabs-nav>

                    <div class="mt-6">
                        @switch (store.activeTabId()) {
                            @case ('episodes') {
                                <details-series [seasons]="store.seasons()" [episodes]="store.episodes()"
                                    [selectedSeasonId]="store.selectedSeasonId()"
                                    [hasUpcomingEnabled]="item.hasUpcomingEnabled"
                                    [hasOutgoingEnabled]="item.hasOutgoingEnabled"
                                    (seasonChange)="store.selectSeason($event)" />
                            }
                            @case ('similar') {
                                <details-vod [items]="store.similar()"
                                    (openItem)="svc.openAsset($event.referenceId)" />
                            }
                            @case ('programme') {
                                <details-live [items]="store.programme()" [selectedId]="store.selectedEpisodeId()"
                                    data-testid="details_epg-program"
                                    (openItem)="svc.openEpg($event.referenceId)" />
                            }
                            @case ('extras') {
                                <details-extras [extras]="store.extras()" (playExtra)="playExtra($event)" />
                            }
                        }
                    </div>
                </div>
            }
        } @else {
            <!-- Nothing loaded. The modal is already open by the time a load fails (loadByHash
                 opens it before dispatching), so without this the visitor gets an empty shell —
                 which is what a backend 404 on a stale referenceId used to produce. Covers every
                 entry point, since they all funnel through the #details hash. -->
            <div class="flex items-center justify-center px-8 py-24 text-center" data-testid="details_error">
                <p class="font-large text-[var(--text_primary)]">
                    {{ 'vod.warning.not_available.message' | transloco }}
                </p>
            </div>
        }
    </div>
</p-dialog>
